/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { Merchant } from './Merchant';
import {
    MerchantFromJSON,
    MerchantFromJSONTyped,
    MerchantToJSON,
    MerchantToJSONTyped,
} from './Merchant';

/**
 * 
 * @export
 * @interface GetMerchantsResponse
 */
export interface GetMerchantsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetMerchantsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<Merchant>}
     * @memberof GetMerchantsResponse
     */
    merchants: Array<Merchant>;
}

/**
 * Check if a given object implements the GetMerchantsResponse interface.
 */
export function instanceOfGetMerchantsResponse(value: object): value is GetMerchantsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('merchants' in value) || value['merchants'] === undefined) return false;
    return true;
}

export function GetMerchantsResponseFromJSON(json: any): GetMerchantsResponse {
    return GetMerchantsResponseFromJSONTyped(json, false);
}

export function GetMerchantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMerchantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'merchants': ((json['merchants'] as Array<any>).map(MerchantFromJSON)),
    };
}

export function GetMerchantsResponseToJSON(json: any): GetMerchantsResponse {
    return GetMerchantsResponseToJSONTyped(json, false);
}

export function GetMerchantsResponseToJSONTyped(value?: GetMerchantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'merchants': ((value['merchants'] as Array<any>).map(MerchantToJSON)),
    };
}

